import React from 'react';
import PropTypes from 'prop-types';
import * as Icon from 'react-feather';

const AiReportList = ({ data = [], onTranscriptClick }) => {
  const sentimentColors = {
    positive: '#008000',
    neutral: '#ffb22b',
    negative: '#ff4560'
  };

  return (
    <div className="report-list-table-wrapper ai-report-list-table-wrapper">
      <table className="report-list-table">
        <thead>
          <tr>
            <th style={{ width: '60%' }}>AI Agent</th>
            <th style={{ width: '20%' }}>Phone Number</th>
            <th className="text-center" style={{ width: '10%' }}>
              Duration
            </th>
            <th className="text-center" style={{ width: '10%' }}>
              Transcript
            </th>
          </tr>
        </thead>
        <tbody>
          {data.length > 0
            ? data.map((row, index) => {
                const bgColor = sentimentColors[row.sentiment] || '#2cabe3';
                return (
                  <tr key={index} style={{ backgroundColor: `${bgColor}33`, fontWeight: 'bold' }}>
                    <td>{row.agentName}</td>
                    <td>{row.phoneNumber || '-'}</td>
                    <td className="text-center">{row.duration || '-'}</td>
                    <td className="text-center">
                      <Icon.FileText
                        size={18}
                        className="cursor-pointer text-primary"
                        onClick={() => onTranscriptClick(row)}
                      />
                    </td>
                  </tr>
                );
              })
            : null}
        </tbody>
      </table>
    </div>
  );
};

AiReportList.propTypes = {
  data: PropTypes.array,
  onTranscriptClick: PropTypes.func.isRequired
};

export default AiReportList;
